<div class="sent-emails">
    <cerrix-title size="large" [editable]="false" [value]="'sentEmails.title' | t"></cerrix-title>

    <div class="top-bar">
        <cerrix-input
            [placeholder]="'sentEmails.searchPlaceholder' | t"
            class="search-input"
            suffixIcon="search"
            [(ngModel)]="searchValue"
            (ngModelChange)="onSearch(false)"
            (keydown.enter)="onSearch(true)"
        ></cerrix-input>

        <page-number-selector
            [pageSize]="pageSize"
            [pageSizeOptions]="[10, 25, 50, 100]"
            (pageNumberChanged)="onPageNumberChanged($event)"
        ></page-number-selector>
    </div>

    <div class="table-container">
        <div class="table-content">
            <table
                mat-table
                [dataSource]="emails"
                matSort
                fixedLayout
                [matSortActive]="sortActive"
                [matSortDirection]="sortDirection"
                (matSortChange)="onSortChange($event)"
            >
                <ng-container matColumnDef="DateSent">
                    <th mat-header-cell *matHeaderCellDef disableClear mat-sort-header>
                        {{ 'sentEmails.dateSentHeader' | t }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.dateSent | dateTimeDisplay: true : true }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="Subject">
                    <th mat-header-cell *matHeaderCellDef disableClear mat-sort-header>{{ 'sentEmails.subjectHeader' | t }}</th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                        [matTooltip]="element.subject"
                        [matTooltipShowDelay]="tooltipDelay"
                    >
                        {{ element.subject }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="To">
                    <th mat-header-cell *matHeaderCellDef disableClear mat-sort-header>
                        {{ 'sentEmails.recipientHeader' | t }}
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                        [matTooltip]="element.to"
                        [matTooltipShowDelay]="tooltipDelay"
                    >
                        {{ element.to }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="EmailStatus">
                    <th mat-header-cell *matHeaderCellDef disableClear mat-sort-header>
                        {{ 'sentEmails.deliveredHeader' | t }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        @if (element.emailStatus === incidentEmailStatus.Sent) {
                            <mat-icon
                                class="email-status-icon sent"
                                fontSet="material-icons-outlined"
                                [matTooltip]="'sentEmails.sentTooltip' | t"
                                >check_circle</mat-icon
                            >
                        } @else if (element.emailStatus === incidentEmailStatus.Failed) {
                            <mat-icon
                                class="email-status-icon error"
                                fontSet="material-icons-outlined"
                                [matTooltip]="'sentEmails.errorTooltip' | t"
                                >warning</mat-icon
                            >
                        } @else {
                            <mat-icon
                                class="email-status-icon"
                                fontSet="material-icons-outlined"
                                [matTooltip]="'sentEmails.pendingTooltip' | t"
                                >pending</mat-icon
                            >
                        }
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                    (click)="openEmail(row)"
                ></tr>

                <tr *matNoDataRow>
                    <ng-container>
                        <td class="no-data-cell" [attr.colspan]="displayedColumns?.length">
                            {{ 'noDataMatchingFilter' | t }}
                        </td>
                    </ng-container>
                </tr>
            </table>
        </div>

        <cerrix-paginator
            [length]="totalEmails"
            [pageIndex]="pageIndex"
            [pageSize]="pageSize"
            [itemsPerPageLabel]="'sentEmails.paginatorLabel' | t"
            (pageIndexChanged)="onPageIndexChanged($event)"
        ></cerrix-paginator>
    </div>
</div>
